export default __webpack_public_path__ + "static/1266-cffb9990e43985dfef311a2f1023e3f6.png";